import { useQuery } from '@tanstack/react-query';
import { getHeaderUpdateTimeViewService } from '../services';

export const useHeaderUpdateTimeView = () => {
  const getUpdateDataStatus = async () => {
    const resp = await getHeaderUpdateTimeViewService();
    return resp;
  };

  const { data, refetch } = useQuery(['header-update-time-view'], getUpdateDataStatus, {
    retry: false,
  });

  return {
    updateData: data?.data,
    refetchUpdate: refetch,
  };
};
